import { LogsService } from '../app/services/logs.service';
import { map } from 'rxjs/operators';

export class DeployTime {
    private static instance: DeployTime | null = null;
    private readonly startupDate: Date;
    private readonly STORAGE_KEY = 'app_startup_time';
    private readonly APP_VERSION_KEY = 'app_version';
    private readonly currentVersion = '2.5.7';
    private commitId: string = 'loading...';
    private logsService: LogsService | null = null;

    private constructor() {
        const storedVersion = localStorage.getItem(this.APP_VERSION_KEY);
        
        if (!storedVersion || storedVersion !== this.currentVersion) {
            this.startupDate = new Date();
            localStorage.setItem(this.STORAGE_KEY, this.startupDate.toISOString());
            localStorage.setItem(this.APP_VERSION_KEY, this.currentVersion);
        } else {
            const storedDate = localStorage.getItem(this.STORAGE_KEY);
            this.startupDate = storedDate ? new Date(storedDate) : new Date();
        }
    }

    static getInstance(logsService?: LogsService): DeployTime {
        if (!DeployTime.instance) {
            DeployTime.instance = new DeployTime();
        }
        if (logsService) {
            DeployTime.instance.setLogsService(logsService);
        }
        return DeployTime.instance;
    }

    private setLogsService(service: LogsService): void {
        this.logsService = service;
        // Trigger commit ID fetch when service becomes available
        this.getLastCommitId();
    }

    getLastCommitId(): string {
            console.log('Fetching commit ID from server...');
            this.logsService.getLastCommitId()
                .pipe(
                    map(response => {
                        // If response is an object with a specific property, extract it
                        if (typeof response === 'object' && response !== null) {
                            console.log('Response is an object:', response);
                            // Assuming the commit ID is in a property like 'commitId' or 'id'
                            return response && (response as any).hasOwnProperty('commitId') ? (response as any)['commitId'] :
                                   response && (response as any).hasOwnProperty('id') ? (response as any)['id'] :
                                   JSON.stringify(response);
                        }
                        return String(response);
                    })
                )
                .subscribe({
                    next: (id: string) => {
                        console.log('Processed commit ID:', id);
                        this.commitId = id || 'unknown';
                        console.log('Updated commit ID:', this.commitId);
                    },
                    error: (error) => {
                        console.error('Error fetching commit ID:', error);
                        this.commitId = 'unknown';
                    }
                });
        
        console.log('Returning current commit ID:', this.commitId);
        return this.commitId;
    }

    getStartupDate(): Date {
        return this.startupDate;
    }

    getFormattedStartupDate(): string {
        return this.startupDate.toLocaleString('de-DE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }

    getVersion(): string {
        return this.currentVersion;
    }

    static resetDeployTime(): void {
        localStorage.removeItem(this.instance?.STORAGE_KEY);
        localStorage.removeItem(this.instance?.APP_VERSION_KEY);
        DeployTime.instance = null;
        location.reload();
    }
}